export default "__VITE_ASSET__EKKZr6Es__"